// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"7b143556","878":"747fcda0","950":"d83555ae"}[chunkId] + ".chunk.js";
};